import apiClient from './apiClient';

export interface HighlightItem {
  highlight_text: string;
  user_id?: number;
  tag_id?: number;
  profile_picture?: string;
  highlight_type: 'mention' | 'hashtag';
  mention_type: 'user' | 'brand' | 'tiktok' | 'instagram' | '';
}

export interface HighlightHashtagItem {
  highlight_text: string;
  highlight_type: 'hashtag';
  count: number;
}

// Cache objects
const userCache: { [key: string]: string } = {};
const tagCache: { [key: string]: string } = {};

export const getUsernameById = async (userId: string): Promise<string> => {
  if (userCache[userId]) {
    return userCache[userId];
  }

  try {
    const response = await apiClient.get(`/core/users/${userId}/username`);
    const username = response.data.username;
    userCache[userId] = username;
    return username;
  } catch (error) {
    console.error('Error fetching username:', error);
    return '';
  }
};

export const getTagNameById = async (tagId: string): Promise<string> => {
  if (tagCache[tagId]) {
    return tagCache[tagId];
  }

  try {
    const response = await apiClient.get(`/tags/${tagId}`);
    const tagName = response.data.name;
    tagCache[tagId] = tagName;
    return tagName;
  } catch (error) {
    console.error('Error fetching tag name:', error);
    return '';
  }
};

export const searchHighlights = async (query: string): Promise<HighlightItem[]> => {
  try {
    const response = await apiClient.get(`/activity/highlight/search/${query}`);
    return response.data.data;
  } catch (error) {
    console.error('Error searching users for mention:', error);
    return [];
  }
};

export const searchHighlightsHashtag = async (query: string): Promise<HighlightHashtagItem[]> => {
  try {
    const response = await apiClient.get(`/activity/highlight/search/hashtag/${query}`);
    return response.data.data;
  } catch (error) {
    console.error('Error searching hashtag:', error);
    return [];
  }
}; 